export default __webpack_public_path__ + "static/media/logo.a9939e12.png";